import { ReactComponent as ArrowLeftIcon } from 'assets/images/arrowLeft2.svg';
import { ReactComponent as ArrowRightIcon } from 'assets/images/arrowRight2.svg';
import { SliderArrow } from 'components/Slider';
import { ScOutsideContainer } from 'components/Slider/styled';
import { useMedia } from 'modules/common/hooks/useMedia';
import type { FC } from 'react';
import { useMemo } from 'react';
import type { ScArrowInsideProps } from './styled';
import {
  ScArrowInsideNext,
  ScArrowInsidePrev,
  ScArrowOutside,
  ScArrowOutsideBox,
} from './styled';

export type SliderPropsWithArrows =
  | ({
      type: SliderArrow.INSIDE;
      alwaysVisible?: boolean;
    } & Pick<
      ScArrowInsideProps,
      'rightArrowPosition' | 'leftArrowPosition' | 'bgArrowButtons'
    >)
  | {
      type: SliderArrow.OUTSIDE;
      hide?: boolean;
      componentLeft?: React.ReactNode;
      componentRight?: React.ReactNode;
    };

export interface ArrowsProps {
  isBeginning: boolean;
  isEnd: boolean;
  isNewUser?: boolean;
  onPrev: () => void;
  onNext: () => void;
  withArrows?: SliderPropsWithArrows;
}

export const Arrows: FC<ArrowsProps> = ({
  withArrows,
  isBeginning,
  isEnd,
  isNewUser,
  onPrev,
  onNext,
}) => {
  const { isMobile } = useMedia();

  const arrowComp = useMemo(() => {
    switch (withArrows?.type) {
      case SliderArrow.INSIDE:
        return withArrows?.alwaysVisible || !isMobile ? (
          <>
            <ScArrowInsidePrev
              bgArrowButtons={withArrows.bgArrowButtons}
              isNewUser={isNewUser}
              onClick={onPrev}
              position={withArrows.leftArrowPosition}
            >
              <ArrowLeftIcon />
            </ScArrowInsidePrev>
            <ScArrowInsideNext
              bgArrowButtons={withArrows.bgArrowButtons}
              isNewUser={isNewUser}
              onClick={onNext}
              position={withArrows.rightArrowPosition}
            >
              <ArrowRightIcon />
            </ScArrowInsideNext>
          </>
        ) : null;

      case SliderArrow.OUTSIDE:
        return (
          <ScOutsideContainer>
            <div className="left-col">{withArrows.componentLeft}</div>
            <div className="right-col">
              {withArrows.componentRight}

              {!(isMobile || withArrows.hide) && (
                <ScArrowOutsideBox>
                  <ScArrowOutside disabled={isBeginning} onClick={onPrev}>
                    <ArrowLeftIcon />
                  </ScArrowOutside>
                  <ScArrowOutside disabled={isEnd} onClick={onNext}>
                    <ArrowRightIcon />
                  </ScArrowOutside>
                </ScArrowOutsideBox>
              )}
            </div>
          </ScOutsideContainer>
        );

      default:
        return null;
    }
  }, [withArrows, isMobile, onPrev, onNext, isBeginning, isEnd, isNewUser]);

  return <>{arrowComp}</>;
};
